export { ProofOfImpactIconRenderer } from './ProofOfImpactIconRenderer'
